import { render, staticRenderFns } from "./table92.vue?vue&type=template&id=0c05187e&scoped=true&"
import script from "./table92.vue?vue&type=script&lang=js&"
export * from "./table92.vue?vue&type=script&lang=js&"
import style0 from "./table92.vue?vue&type=style&index=0&id=0c05187e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05187e",
  null
  
)

export default component.exports